import { render, staticRenderFns } from "./UiPayouts.vue?vue&type=template&id=3002cf7d&"
import script from "./UiPayouts.vue?vue&type=script&lang=js&"
export * from "./UiPayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports